<template>
  <v-dialog v-model="dialog" max-width="800">
    <v-card class="terms-modal__card">
      <v-card-title class="terms-modal__title">
        <span>Termos e Condições</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="terms-modal__content pa-0">
        <iframe v-if="pdfUrl" :src="pdfUrl" class="terms-modal__pdf-viewer" frameborder="0"></iframe>
        <div v-else class="terms-modal__no-content">
          <p>Não foi possível carregar os termos.</p>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="terms-modal__actions py-3">
        <v-spacer></v-spacer>
        <v-btn
          :style="{
            'background-color': buttonBackgroundColor,
            color: buttonFontColor
          }"
          @click="acceptTerms"
        >
          Aceitar termos
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TermsModal',
  props: {
    termsUrl: {
      type: String,
      default: ''
    },
    buttonBackgroundColor: {
      type: String,
      default: '#1976d2'
    },
    buttonFontColor: {
      type: String,
      default: '#ffffff'
    }
  },
  data: () => ({
    dialog: false
  }),
  computed: {
    pdfUrl() {
      if (!this.termsUrl) return ''
      // Add parameters to hide toolbar and navigation pane
      return `${this.termsUrl}#toolbar=0&navpanes=0`
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    acceptTerms() {
      this.dialog = false
      this.$emit('accept')
    }
  }
}
</script>

<style scoped lang="scss">
.terms-modal__card {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.terms-modal__title {
  flex-shrink: 0;
}

.terms-modal__content {
  flex: 1;
  overflow: hidden !important;
  min-height: 400px;
  height: 500px;
}

.terms-modal__pdf-viewer {
  width: 100%;
  height: 100%;
  min-height: 500px;
}

.terms-modal__no-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 300px;
  color: #666;
}

.terms-modal__actions {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}
</style>
